import { RangePickerProps } from 'antd/es/date-picker';

export const disabledDateFunc =
	(days: number): RangePickerProps['disabledDate'] =>
	(current, { from }) => {
		if (!current) return false;

		if (from) {
			const tooEarly = current.isBefore(from.startOf('day').subtract(days, 'day'));
			const tooLate = current.isAfter(from.startOf('day').add(days, 'day'));
			return tooEarly || tooLate;
		}

		return false;
	};
